import Promise$1 from 'bluebird';
import { TrackingMapper } from './TrackingMapper.js';

class TrackingRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * Returns tracking for a particular shipment
   *
   * @param shipmentReference Shipment reference string
   * @returns Tracking information
   */
  getByShipmentReference(shipmentReference) {
    if (!shipmentReference) {
      return Promise$1.reject(new Error('Check that your shipmentReference is valid.'));
    }
    return this.apiClient.get(`v1/trackings/${shipmentReference}`).then(_ref => {
      let {
        data
      } = _ref;
      return TrackingMapper.createModelFromResponse(data);
    });
  }
}

export { TrackingRepository };
//# sourceMappingURL=TrackingRepository.js.map
